/*
 * @Author: 晾衣架 1308251352@qq.com
 * @Date: 2023-07-25 09:12:38
 * @LastEditors: 晾衣架 1308251352@qq.com
 * @LastEditTime: 2023-08-02 13:33:36
 * @FilePath: /m-terminal-PC/src/router/routes/modules/member.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type { AppRouteModule } from '/@/router/types';

import { LAYOUT2 } from '/@/router/constant';
import { t } from '@mcex/locale';
import { PropType } from 'vue';
import type { Menu } from '/@/router/types';
import { PageEnum } from '/@/enums/pageEnum';
import { MenuCodeEnum } from '/@/enums/menuCodeEnum';
//import { useRegisterFormStore } from '/@/store/modules/registerForm';
// import { MEMBER_DOMAIN_MAP } from '/@/api/const';
import { useAppStore } from '/@/store/modules/app';

// 系统通知
const sysNotification: AppRouteModule[] = [
  {
    path: '/sysNotification',
    name: 'sysNotification',
    component: LAYOUT2,
    redirect: PageEnum.SYS_NOTIFICATION_LIST + '/:nType?',
    meta: {
      orderNo: 3,
      icon: 'menus-notification|svg',
      hideChildrenInMenu: true,
      title: t('sys.notification'),
      // menuCodes: [MenuCodeEnum.sysNotification],
      ignoreAuth: false,
      contentRender: (item: PropType<Menu>, defaultVn) => {
        const appStore = useAppStore();
        return (
          <div class="relative">
            {defaultVn()}
            {appStore.getSysNotifyFlag ? (
              <div class="absolute w-2 h-2 rounded-full bg-[#E90031] top-0.5 -right-1.5"></div>
            ) : (
              ''
            )}
          </div>
        );
      },
    },
    children: [
      {
        path: 'list/:nType?',
        props: true,
        name: 'SysNotificationList',
        component: () => import('/@/views/sys/notification/index.vue'),
        meta: {
          title: t('sys.notification'),
          ignoreAuth: false,
        },
        beforeEnter: (to, _from, next) => {
          const nType = to.params.nType;
          if (nType === ':nType') {
            next({ path: PageEnum.SYS_NOTIFICATION_LIST });
          } else {
            next();
          }
        },
      },
    ],
  },
];

export default sysNotification;
